const customer_reviews_swiper = new Swiper('.customer-reviews', {
    speed: 3000,
    spaceBetween: 20,
    grabCursor: true,
    slidesPerView: 1.055,
    slidesPerGroup: 1,
    loop: true,
    pagination: {
        el: '.customer-review__section .swiper__dots',
        clickable: true,
        type: 'bullets',
        renderBullet: function (index, className) {
            return `<span class="${className} custom-bullet">  
                  </span>`;
        }    
    },
    breakpoints: {
        1300: {
            slidesPerView: 3.4,
            slidesPerGroup: 2
        },
        600: {
            slidesPerView: 2.4,
            slidesPerGroup: 2
        }
    }
});

document.querySelector(".customer-review__section .swiper__next").addEventListener("click", () => {
    customer_reviews_swiper.slideNext();
})
document.querySelector(".customer-review__section .swiper__prev").addEventListener("click", () => {
    customer_reviews_swiper.slidePrev();
})